"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseTerm = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./PurchaseTerm.css"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _TermCard = require("../TermCard");
var _clsx = _interopRequireDefault(require("clsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PurchaseTerm = props => {
  const {
    term,
    onClick,
    collapsed,
    handleCollapse,
    linkedPromos,
    setPreparedPromo,
    setIsFulllPriceMethod,
    fullCreditPriceTooltip
  } = props;
  const ref = React.useRef(null);
  const scrollToRef = () => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const handleClickWithScroll = () => {
    onClick();
    scrollToRef();
  };
  const handleCollapseWithScroll = () => {
    handleCollapse();
    scrollToRef();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: style['term'],
    ref: ref
  }, term.title && /*#__PURE__*/React.createElement("div", {
    className: style['header']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, term.title), term.moreText && /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['collapse-control'], collapsed && style['visible'])
  }, /*#__PURE__*/React.createElement(_uiKit.ActionLink, {
    fontWeight: "bold",
    color: "current_color",
    onClick: handleClickWithScroll,
    afterIcon: /*#__PURE__*/React.createElement(_icons.IconActionChevronDownSmall16, {
      color: "icon-main-default"
    })
  }, term.moreText))), /*#__PURE__*/React.createElement(_TermCard.TermCard, {
    method: term.purchasingMethods[0],
    linkedPromos: linkedPromos,
    type: term.type,
    setPreparedPromo: setPreparedPromo,
    setIsFulllPriceMethod: setIsFulllPriceMethod,
    fullCreditPriceTooltip: fullCreditPriceTooltip
  }), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(style['collapsed-content'], collapsed && style['collapsed-content-hidden'])
  }, term.purchasingMethods.map((method, index) => {
    if (index === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(_TermCard.TermCard, {
      method: method,
      key: index,
      linkedPromos: linkedPromos,
      type: term.type,
      setPreparedPromo: setPreparedPromo,
      setIsFulllPriceMethod: setIsFulllPriceMethod,
      fullCreditPriceTooltip: fullCreditPriceTooltip
    });
  })), term.moreText && !collapsed && /*#__PURE__*/React.createElement("div", {
    className: style['collapse-button']
  }, /*#__PURE__*/React.createElement(_uiKit.ActionLink, {
    fontWeight: "bold",
    color: "current_color",
    onClick: handleCollapseWithScroll,
    afterIcon: /*#__PURE__*/React.createElement(_icons.IconActionChevronUpSmall16, {
      color: "icon-main-default"
    })
  }, "\u0421\u043A\u0440\u044B\u0442\u044C")));
};
exports.PurchaseTerm = PurchaseTerm;